import React, { useState, useEffect } from "react";
import {moment,GoogleMaps} from "../../../../../vendor";


const GoogleMap = (props) => {

    const [initialized,setInitialized] = useState(false);
    const [map,setMap] = useState(null);
    const [mapReference,setMapReference] = useState(null);
    const [mapOffset,setMapOffset] = useState(0);
    const [markers,setMarkers] = useState([]);                      // google maps map markers
    const [activeMarker,setActiveMarker] = useState(null);          // set active by onclick event
    const [closeClicked,setCloseClicked] = useState(moment().format('x'));
    const [containerStyle,setContainerStyle] = useState({
        width: '100%',
        height: '100%',
        marginLeft: '0',
        marginTop: '0',
        color: 'white',
        headerHeight: '60px',
        footerHeight: '55px',
        mapHeight: '100%',
        isInitialized: false
    });

    const setMapCenter = () => {

        if (typeof props.center !== 'undefined' && props.center != null && typeof props.center.latitude !== 'undefined' && typeof props.center.longitude !== 'undefined') {
            map.setCenter({
                lat: parseFloat(props.center.latitude),
                lng: parseFloat(props.center.longitude)
            });
            return;
        }

        if (markers.length == 0) {
            if (typeof props.defaultCenter !== 'undefined' && props.defaultCenter != null && typeof props.defaultCenter.latitude !== 'undefined' && typeof props.defaultCenter.longitude !== 'undefined') {
                map.setCenter({
                    lat: parseFloat(props.defaultCenter.latitude),
                    lng: parseFloat(props.defaultCenter.longitude)
                });
            } else {
                map.setCenter({
                    lat: 0.0,
                    lng: 0.0
                });
            }
        }

        if (markers.length == 1) {
            map.setCenter({
                lat: parseFloat(markers[0].position.lat()),
                lng: parseFloat(markers[0].position.lng())
            });
        }

        if (markers.length > 1) {

            let bounds = new mapReference.maps.LatLngBounds();

            for (let i = 0; i < markers.length; i++) {
              bounds.extend(markers[i].getPosition());
            }

            map.fitBounds(bounds, {top:0,bottom:(180),left:0,right:0});
        }
    };

    const initialize = () => {
        // Init map and pass it as reference to childViews
    
        if (initialized === true) return;
        if (map != null) return;
    
        // Free from memory
        if (document.getElementById('map')) {
          console.log("map already exists!");
          // remove existing instance of map
          //  that._mapReference.maps.event.clearInstanceListeners(document.getElementById('map'));
          return;
        }
    
        GoogleMaps.KEY = 'AIzaSyA-KYu6ZYUf3ISccsHsweCIGMKNn0jrefY';//'AIzaSyA7nXDt2yy8x347fyUHd_TM8bEKN5dLfS0';
        GoogleMaps.VERSION = 'weekly';

        if (document.getElementById('inb-google-map') == null) return;
    
        GoogleMaps.load(function(google) {

          setMapReference(google);

          var _map = new google.maps.Map(document.getElementById('inb-google-map'), {
            zoom: props.zoomLevel,
            mapTypeControlOptions: { mapTypeIds: [] }
          });

          if (typeof props.onMapInitialized === 'function') {
            props.onMapInitialized(_map,google);
          }
    
          setMap(_map);
        });
        setInitialized(true);
    };

    // attributes set by: containerSize, containerColor, marginLeft, marginTop
    const initializeStyle = () => {

        if (containerStyle.isInitialized) return;

        let clone = {...containerStyle};

        if (typeof props.containerSize !== 'undefined') {
            
            if (typeof props.containerSize.width !== 'undefined') {
                let width = props.containerSize.width;
                if (width.endsWith('%') && parseFloat(width) >= 0) {
                    clone.width = width;
                }
                if (width.endsWith('px') && parseFloat(width) >= 0) {
                    clone.width = width;
                }
            }

            if (typeof props.containerSize.height !== 'undefined') {
                let height = props.containerSize.height;
                if (height.endsWith('%') && parseFloat(height) >= 0) {
                    clone.height = height;
                }
                if (height.endsWith('px') && parseFloat(height) >= 0) {
                    clone.height = height;
                }
            }
        }

        if (typeof props.containerMargin !== 'undefined') {

            if (typeof props.containerMargin.left !== 'undefined') {
                let left = props.containerMargin.left;
                if (left.endsWith('%') && parseFloat(left) >= 0) {
                    clone.marginLeft = left;
                }
                if (left.endsWith('px') && parseFloat(left) >= 0) {
                    clone.marginLeft = left;
                }
            }

            if (typeof props.containerMargin.top !== 'undefined') {
                let top = props.containerMargin.top;
                if (top.endsWith('%') && parseFloat(top) >= 0) {
                    clone.marginTop = top;
                }
                if (top.endsWith('px') && parseFloat(top) >= 0) {
                    clone.marginTop = top;
                }
            }
        }

        if (typeof props.containerColor !== 'undefined') {
            clone.color = props.containerColor;
        }

        if (typeof props.hasHeader !== 'undefined' && props.hasHeader === true) {
            clone.mapHeight = 'calc(100% - ' + clone.headerHeight + ')';
        }

        if (typeof props.hasFooter !== 'undefined' && props.hasFooter === true) {
            if (clone.mapHeight != '100%') {
                clone.mapHeight = 'calc(100% - ' + clone.headerHeight + ' - ' + clone.footerHeight + ')';
            } else {
                clone.mapHeight = 'calc(100% - ' + clone.footerHeight + ')';
            }
        }
        clone.isInitialized = true;
        setContainerStyle(clone);
    };

    const updateMapMarker = () => {

        if (mapReference === null) return;

        if (map === null) return;

        if (markers.length != props.markers.length) {
            // create new marker array
            let clone = [];
            let markerIcon = {};
            for (var i=0;i<props.markers.length;i++) {
                if (props.markers[i].imageDownScale) {
                    markerIcon.url = props.markers[i].imageUrl, // url
                    markerIcon.scaledSize = new mapReference.maps.Size(props.markers[i].imageSize.width, props.markers[i].imageSize.height), // eventually scale down
                    markerIcon.origin = new mapReference.maps.Point(0,0), // origin
                    markerIcon.anchor = new mapReference.maps.Point(0, 0) // anchor
                }
                clone.push(new mapReference.maps.Marker({
                    map: map,
                    //index: i,
                    //title: (props.markers[i].title + " (" + i + ")"),
                    position: {
                      lat: parseFloat(props.markers[i].latitude),
                      lng: parseFloat(props.markers[i].longitude)
                    },
                    icon: props.markers[i].imageDownScale ? markerIcon : props.markers[i].imageUrl,
                    draggable: props.markers[i].draggable
                }));
            }
            for (var j=0;j<clone.length;j++) {
                clone[j].addListener('click', (e) => {mapMarkerClickHandle(e)});
            }
            setMarkers(clone);
            setMapCenter();
        } else {
            let clone = [...markers];
            let doPositionUpdate = false;
            let doInfoUpdate = false;
            // check positions for updates
            for (var i=0;i<props.markers.length;i++) {
                if (typeof clone[i].position !== 'undefined' && (clone[i].position.lat() != parseFloat(props.markers[i].latitude) || clone[i].position.lng() != parseFloat(props.markers[i].longitude))) {
                    clone[i].setPosition( new mapReference.maps.LatLng(
                        parseFloat(props.markers[i].latitude),
                        parseFloat(props.markers[i].longitude))
                    );
                    doPositionUpdate = true;
                }
                // user interactions by closing info windows force an immediate re-render which MUST be blocked to prevent an infinite render loop
                if ((moment().format('x') - closeClicked) < 1000) return;
                if ((typeof clone[i].info === 'undefined' || clone[i].info == null) && typeof props.markers[i].info !== 'undefined' && props.markers[i].info != null) {

                    // close previous marker info
                    if (activeMarker != null && activeMarker >= 0 && activeMarker < clone.length && typeof clone[activeMarker].infoWindow !== 'undefined') {
                        console.log("close previous opened window");
                        clone[activeMarker].infoWindow.close();             // caution: event handler is not called if closed manually
                        delete clone[activeMarker].infoWindow;
                        clone[activeMarker].info = null;
                        //setMarkers(clone);
                        if (typeof props.removeMarkerInfo === 'function') props.removeMarkerInfo(activeMarker);
                    }

                    // show (new) marker info
                    setActiveMarker(i);
                    clone[i].infoWindow = new mapReference.maps.InfoWindow({
                        content: props.markers[i].info,
                        zIndex: 100
                    });

                    let j=i;
                    mapReference.maps.event.addListener(clone[i].infoWindow,'closeclick',function(){
                        // store timestamp of event to distinguish between user interactions and re-render
                        console.log("onclose infowindow");
                        setCloseClicked(moment().format('x'));
                        delete clone[j].infoWindow;
                        clone[j].info = null;
                        setMarkers(clone);
                        if (typeof props.removeMarkerInfo === 'function') props.removeMarkerInfo(j);
                    });
                    
                    clone[i].infoWindow.open(map, markers[i]);
                    map.setCenter(clone[i].infoWindow.getPosition());
                    clone[i].info = props.markers[i].info;
                    doInfoUpdate = true;
                }
            }
            if (doPositionUpdate || doInfoUpdate) setMarkers(clone);
            else setMapCenter();
        }
        setMapCenter();
    }

    useEffect(() => {

        // has fixed position (does not follow scrolling) - default: true
        // explicitly set to false?
        if (typeof props.hasFixedPosition !== 'undefined' && props.hasFixedPosition === false) {
            window.onscroll = () => {
                setMapOffset(window.pageYOffset);
            }
        }
    });

    const mapMarkerClickHandle = (e) => {

        const position = {
            lng: e.latLng.lng(),
            lat: e.latLng.lat()
        };

        // get index using position
        for(var i=0;i<props.markers.length;i++) {
            if (props.markers[i].longitude == position.lng && props.markers[i].latitude == position.lat) {
                if (typeof props.onClickMarkerHandler === 'function') props.onClickMarkerHandler(i);
                return;
            }
        }
    };

    initialize();

    initializeStyle();

    updateMapMarker();

    return(
        <>
        {typeof props.status !== 'undefined' && props.status > 0 &&
        <>
            { typeof props.hasOverlay !== 'undefined' && props.hasOverlay === true &&
                <div className={props.status < 2 ? 'js-off-canvas-overlay is-overlay-fixed' : 'js-off-canvas-overlay is-overlay-fixed is-visible'} style={{zIndex:'1'}}></div>
            }
            <div className={props.status < 2 ? 'hide' : ''}
                 style={{position:'absolute',width: containerStyle.width,height:containerStyle.height,left:containerStyle.marginLeft,top:("calc(" + containerStyle.marginTop + " + " + mapOffset+"px)"),zIndex:'2',backgroundColor:'white'}}>
                { typeof props.hasHeader !== 'undefined' && props.hasHeader === true &&
                    <div style={{height: containerStyle.headerHeight,width: '100%',paddingTop: '0.5rem',paddingRight:'0.8rem'}}>
                        <a><button type="button" style={{marginBottom:'0'}} className="button hollow secondary right button-abort round" title="Fenster schließen" onClick={() => onCloseMap()}>
                            <i className="fi fi-x" style={{padding: '0'}}></i>
                        </button></a>
                    </div>
                }
                <div id="inb-google-map" className={"full" + map != null ? '' : ' hide'} style={{position:'relative',overflow:'hidden',width:'100%',height:containerStyle.mapHeight}}>
                </div>
                { typeof props.hasFooter !== 'undefined' && props.hasFooter === true &&
                    <div style={{textAlign:'center',paddingTop:'10px'}}>
                        <div style={{display: 'inline',marginTop: '8px'}}>
                            <img src="https://maps.google.com/mapfiles/ms/icons/blue-dot.png"/>
                            <span>App Position</span>
                        </div>
                        { props.status > 2 &&
                            <div style={{display: 'inline',marginLeft: '5%',marginTop: '8px'}}>
                                <img src="https://maps.google.com/mapfiles/ms/icons/red-dot.png"/>
                                <span>iLockIt Position</span>
                            </div>
                        }
                    </div>
                }
            </div>
        </>
        }
        </>
    );

};

export default GoogleMap;
